module.exports = ":host {\n  width: 25vw; }\n\n.block {\n  margin: auto; }\n\n.history-list {\n  height: 65vh;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/passengers/details/details.component.scss
// module id = ./src/app/passengers/details/details.component.scss
// module chunks = main